<template>
    <div class="news-main">
        <!-- 头部 -->
      <headers></headers>
        <div style="background: #fff; padding-bottom: 100px; padding-top: 100px;">
            <section class="col news-con">
                <div class="news-l">
                    <div class="link-bar">当前位置：<a href="news">新闻动态</a> > <a href="javascript:;" id="category">行业新闻</a> > <span id="msg"></span></div>
                    <div class="new-detail" id="new-detail"></div>
                </div>
                <div class="news-r">
                    <div class="news-t">最新文章</div>
                    <ul class="news-list2" id="news-list2">
                    </ul>
                    <div class="news-code">
                        <img src="../images/code-news.png" alt="">
                        <div>
                            <p>会展通讯社</p>
                            <span>及时、有料的会展新闻与行业动态！</span>
                        </div>
                    </div>
                </div>
                
            </section>
        </div>
        <!-- 尾部 -->
      <footers></footers>
      <!-- 右侧吸附客服咨询按钮 -->
      <contact></contact>
    </div>
</template>
    <script>
    import $ from 'jquery';
    import headers from '@/common/header';
    import footers from '@/common/Footer';
    import contact from '@/components/contact';
    export default {
        components: {
            headers,
            footers,
            contact
        },
        mounted() {
            var _api = 'https://scm-member-api.expopaas.com'
        var id = getUrlParamValue('id')
        var category = getUrlParamValue('type')
        console.log("id",id);
        

        var _category = {
            '最新文章': 'news',
            '全部': 'all',
            '企业动态': 'qydt',
            '行业动态': 'hydt'
        }
        var _category2 = {
            'news': '最新文章',
            'all':'全部',
            'qydt':'企业动态',
            'hydt':'行业动态'
        }
        $('#category').html(_category2[category]).attr('href','news?type='+category)
        if(id){
            get_news_detail(id, category)
        }
        
        get_news()
        function getUrlParamValue(name){
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
            var r = window.location.search.substr(1).match(reg);  //匹配目标参数
            if (r != null) return unescape(r[2]); return null; //返回参数值
        }
        function formatDate (value) {
            let date = new Date(value);
            if(date == 'Invalid Date'){
                return ''
            }
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
        }
        function get_news(){
            $.ajax({
                type: "get",
                url: _api+"/web/v1/article/info/getList",
                data: {
                    cateId: '3', //qydt''企业动态 hydt：行业动态 all：全部 news 最新文章
                    pageNum: 1, // 页码
                    pageSize: 8,
                },
                dataType: "json",
                success: function (res) {
                    if (res.code == 0) {
                        set_news2(res.data.data) 
                    }else{

                    }
                }
            });
        }

        function set_news2(list){
            var html = ''
            for(var i=0,j=list.length; i<j; i++){
                var item = list[i]
                html += '<li>'+
                            '<label class="'+(i<3?'active':'')+'">'+(i+1)+'</label>'+
                            '<div>'+
                                '<a href="?id='+item.id+'&type=news" style="color:#5294F9; font-weight: 400;">'+item.title+'</a>'+
                                '<span>'+item.time+'</span>'+
                            '</div>'+
                        '</li>'
            }
            $('#news-list2').html(html)
        }

        function get_news_detail(id,category){
            
            $.ajax({
                type: "get",
                url: _api+"/web/v1/article/info/getDetail",
                data: {
                    id: id,
                },
                dataType: "json",
                success: function (res) {
                    console.log(res)
                    if (res.code == 0) {
                        // set_news2(res.data)
                        var data = res.data
                        
                        $('#msg').html(data.title)
                        var html = '<div class="new-title">'+data.title+'</div>'+
                            '<div class="_msg"><span>'+data.time+'</span> <span>来源 : '+data.cateName+'</span> <span>浏览次数 : '+data.num+'</span></div>'+
                            '<div class="_content">'+data.content+'</div>'+
                            '<div class="_p">';
                            if(data.lastId){
                                html += '<a href="?id='+data.lastId+'&type='+'new'+'">上一篇 : '+data.lastTitle+'</a>'
                            }else{
                                html += '<span></span>'
                            }
                            if(data.nextId){
                                html += '<a href="?id='+data.nextId+'&type='+'new'+'">下一篇 : '+data.nextTitle+'</a>'
                            }else{
                                html += '<span></span>'
                            }
                            html += '</div>'
                        $('#new-detail').html(html)
                    }else{

                    }
                }
            });
        }
    }
}


    </script>


// WEBPACK FOOTER //
// src/page/news-detail.vue